//@ts-nocheck
import React from 'react'

import { Toolbar as ToolbarWrapper } from './Toolbar'
import { HoveringToolbar } from './HoveringToolbar'
import BaseToolbar from './BaseToolbar';

export declare interface MainToolbarProps {
  contentStack: boolean,
  customToolbarComponents: any,
  toolbarMode: any,
  templateregistrycondition: any,
  className: any,
  fieldName: string,
  editorRef: any,
  FullScreenToggle: React.ReactNode
}

const MainToolbar = React.memo((props: Partial<MainToolbarProps>) => {
  const {
    contentStack,
    customToolbarComponents,
    toolbarMode = 'advance',
    fieldName,
    editorRef,
    FullScreenToggle
  } = props
  let propsCopy = { ...props }
  delete propsCopy['contentStack']
  delete propsCopy['toolbarMode']
  delete propsCopy['customToolbarComponents']

  return (
    <ToolbarWrapper {...propsCopy}>
      <BaseToolbar
        toolbarType={'mainToolbar'}
        contentStack={contentStack}
        toolbarMode={toolbarMode}
        customToolbarComponents={customToolbarComponents}
        fieldName={fieldName}
        editorRef={editorRef}
        FullScreenToggle={FullScreenToggle}
      />
    </ToolbarWrapper>
  )
}, (prev, next) => {
  return prev.FullScreenToggle === next.FullScreenToggle;
})

export { MainToolbar, HoveringToolbar }
